import api, { BASE_DOMAIN, ensureCsrfCookie } from "../axiosConfig";

const tenantParams = (tenantCode) =>
  tenantCode
    ? {
        params: { tenant: tenantCode },
      }
    : {};

const getSetup = async (tenantCode = "") => {
  await ensureCsrfCookie();
  const res = await api.get("/enterprise/setup", tenantParams(tenantCode));
  return res.data;
};

const listTenants = async () => {
  await ensureCsrfCookie();
  const res = await api.get("/enterprise/tenants");
  return res.data;
};

const createTenant = async (payload = {}) => {
  await ensureCsrfCookie();
  const res = await api.post("/enterprise/tenants", payload);
  return res.data;
};

const updateTenantProfile = async (payload = {}, tenantCode = "") => {
  await ensureCsrfCookie();
  const res = await api.put("/enterprise/tenant-profile", payload, tenantParams(tenantCode));
  return res.data;
};

const saveIdentityProvider = async (payload = {}, tenantCode = "") => {
  await ensureCsrfCookie();

  const path = payload.id
    ? `/enterprise/identity-providers/${payload.id}`
    : "/enterprise/identity-providers";
  const method = payload.id ? "patch" : "post";
  const res = await api[method](path, payload, tenantParams(tenantCode));
  return res.data;
};

const updateUserPermissions = async (userId, overrides = {}, tenantCode = "") => {
  await ensureCsrfCookie();
  const res = await api.put(
    `/enterprise/users/${userId}/permissions`,
    { overrides },
    tenantParams(tenantCode)
  );
  return res.data;
};

const listPublicIdentityProviders = async (tenantCode = "") => {
  const res = await api.get("/enterprise/identity-providers/public", {
    baseURL: `${BASE_DOMAIN}/api`,
    withCredentials: true,
    params: tenantCode ? { tenant: tenantCode } : undefined,
  });
  return res.data;
};

const getPublicContext = async (tenantCode = "") => {
  const res = await api.get("/enterprise/public-context", {
    baseURL: `${BASE_DOMAIN}/api`,
    withCredentials: true,
    params: tenantCode ? { tenant: tenantCode } : undefined,
  });
  return res.data;
};

export const enterpriseSetupApi = {
  getSetup,
  listTenants,
  createTenant,
  updateTenantProfile,
  saveIdentityProvider,
  updateUserPermissions,
  listPublicIdentityProviders,
  getPublicContext,
};

export default enterpriseSetupApi;
